import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { BeneficiarySoaSubmitDetail } from '../models/submit-soa-model'
import { ValidatedDateTextField } from '../../validations/validated-date-text-field.component'
import { Validatable } from '../../validations/validatable'
import { CurrentUser } from '../../common/models/current-user'
import { CurrentUserForESoa } from '../../common/models/current-user-for-esoa'
import { UserAccessGateway } from '../../common/gateways/user-access-gateway'
import { EmailAddressTextFieldValidator } from '../../validations/email-address-text-field-validator'
import { PhoneNumberInputMask } from '../../common/input-masks/phone-number.input-mask'
import { NumericTextFieldValidator } from '../../validations/numeric-text-field-validator'
import { NotBlankGenericFieldValidator } from '../../validations/not-blank-generic-field-validator'
import { FormValidationService } from '../../validations/form-validation-service'
import { SOAFormSubmissionGateWay } from '../gateways/soa-form-submission-gateways'
import { Router, ActivatedRoute } from '@angular/router'
import { PortalGlobals } from '../../../app/portalglobals'
import { EnrollmentGateway } from '../../enrollment/gateways/enrollment-gateway'
import { GoodStandingModel } from '../../common/models/good-standing-model'
import { TrainingCertificatesGateway } from '../../training/gateways/training-certificates-gateway'
import { EnrollmentHeader } from '../../enrollment/models/EnrollmentHeader'
import { EnrollmentField } from '../../enrollment/models/enrollment-field'
import { ExternalEnrollmentFieldCodes } from '../../enrollment/models/ExternalEnrollmentFieldCodes'
import { UserDataService } from '../../user-management/gateways/user-data-service'
import * as moment from 'moment'
@Component({
    selector: 'submitsoa',
    templateUrl: 'soa-form-submission.component.html',
    styleUrls: ['soa-form-submission.component.scss']
})
export class SubmitElectronicSOAComponent extends Validatable<BeneficiarySoaSubmitDetail> implements OnInit {
    @Input() disabled = false
    @Output() onValueChange: EventEmitter<BeneficiarySoaSubmitDetail> = new EventEmitter<BeneficiarySoaSubmitDetail>()

    @Output() onSubmitSOADetails: EventEmitter<BeneficiarySoaSubmitDetail> = new EventEmitter<BeneficiarySoaSubmitDetail>()
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    public currentUser: CurrentUser = {} as CurrentUser
    public currentUserForESoa: CurrentUserForESoa = {} as CurrentUserForESoa
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new ValidatedDateTextField()
    emailValidator = new EmailAddressTextFieldValidator()
    phoneNumberInputMask = new PhoneNumberInputMask()

    numericValidator = new NumericTextFieldValidator()

    @Input() soaSubmitDetails: BeneficiarySoaSubmitDetail

    // validation fields begin
    isFormValid: boolean

    specialCharacterAgentNameError: string
    agentNameError: string

    agentPhoneError: string
    agentPhoneFormatError: string

    agentAddressError: string

    beneficiaryNameError: string
    specialCharacterBeneficiaryNameError: string

    beneficiaryPhoneError: string
    beneficiaryPhoneFormatError: string

    beneficiaryAddressError: string

    beneficiaryMethodOfContactError: string
    specialCharacterBeneficiaryMethodOfContactError: string

    agentSignatureError: string
    specialCharacterAgentSignatureError: string

    dateOfAppointmentError: string
    dateofAppointmentValidValueError: string

    beneficiaryEmailError: string
    specialCharacterbeneficiaryEmailError: string

    txtWhyNoDocsError: string
    planError: string

    haserror: boolean = false
    trainingMsg: boolean = false
    backgroundMsg: boolean = false
    trainingFailedMsg: boolean = false
    licencemsg: boolean = false
    validAgent: boolean = false
    public loading: boolean = false
    enrollmentHeader: EnrollmentHeader = {} as EnrollmentHeader
    DynamicPlanYear: boolean = false
    insuranceCompany: string
    insuranceCompanyShortName: string
    // validation fields end

    constructor(
        formValidationService: FormValidationService,
        private _networkUserAccessGateway: UserAccessGateway,
        public gateway: EnrollmentGateway,
        private trainingCertificatesGateway: TrainingCertificatesGateway,
        private router: Router,
        private soaFormSubmissionGateWay: SOAFormSubmissionGateWay,
        public _global: PortalGlobals,
        private route: ActivatedRoute,
        private userdataservice: UserDataService,
        private routers: Router
    ) {
        super(formValidationService)
    }

    ViewSOAHistory() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        if (insCo === undefined || insCo === null) this.router.navigate(['ssi/electronic-soa/viewsoa'])
        else this.router.navigate(['/' + insCo + '/electronic-soa/viewsoa'])
    }

    ngOnInit() {
        if (this._global.selectedPlanYear === undefined || this._global.selectedPlanYear === 0) {
            this.setPlanYear()
        } else {
            this.setPageData()
        }
    }

    setPageData() {
        if (this._global.selectedPlanYear.toString() === this._global.AEPPlanYearValue) {
            this.DynamicPlanYear = true
        }
        if (sessionStorage.getItem('GoodStandingParams') != null) {
            this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams')!)
            if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
                this.haserror = true
                this.trainingMsg = !this.goodStandingValues.CurriculumStatus
                this.backgroundMsg = !this.goodStandingValues.BackgroundCheckStatus
                this.licencemsg = !this.goodStandingValues.LicenseStatus
            } else {
                this.haserror = false
                this.trainingMsg = false
                this.backgroundMsg = false
                this.licencemsg = false
                this.validAgent = true
                this.soaSubmitDetails = {} as BeneficiarySoaSubmitDetail
                this.isFormValid = true

                // getting user object from session
                this._networkUserAccessGateway.getCurrentUser().subscribe((user) => {
                    if (user != null) {
                        this.currentUser = user
                        this._global.currentUser = user
                        this.soaSubmitDetails.AgentName = this.currentUser.firstName + ' ' + this.currentUser.lastName

                        this.soaSubmitDetails.OrgID = this.currentUser.orgId
                        this.soaSubmitDetails.UserProfileID = this.currentUser.userProfileId
                        this.soaSubmitDetails.RecCreateUserID = this.currentUser.userProfileName
                        this.soaSubmitDetails.LastUpdateUserID = this.currentUser.userProfileName
                        this.soaSubmitDetails.AgentUserProfileName = this.currentUser.userProfileName
                        this.soaSubmitDetails.PlanYear = this._global.selectedPlanYear
                        this.setAgentDetails()
                    } else {
                        // already exists in session
                        this.soaSubmitDetails.AgentName = this.currentUser.userProfileName
                        this.soaSubmitDetails.OrgID = this.currentUser.orgId
                        this.soaSubmitDetails.UserProfileID = this.currentUser.userProfileId
                        this.soaSubmitDetails.RecCreateUserID = this.currentUser.userProfileName
                        this.soaSubmitDetails.LastUpdateUserID = this.currentUser.userProfileName
                        this.soaSubmitDetails.AgentUserProfileName = this.currentUser.userProfileName
                        this.soaSubmitDetails.PlanYear = this._global.selectedPlanYear
                        this.setAgentDetails()
                    }
                    this.setOrgname()
                })
            }
        }
    }

    setPlanYear() {
        this._networkUserAccessGateway.getCurrentPlanYears().subscribe((planYears) => {
            this._global.availablePlanYears = planYears
            this.userdataservice.changeAvailableYears(planYears)
            if (planYears !== null) {
                if (planYears.length > 1) {
                    // making the max logic eloborate so that if we change planyears
                    // from number to a complex object its easy to accomodate.
                    var planYearStr: any
                    planYearStr = sessionStorage.getItem('PLANYEAR')
                    if (planYearStr === null || planYearStr === 0) {
                        //this._global.selectedPlanYear = planYears[1]
                        let currentyear = moment().get('year')
                        if (currentyear === planYears[0]) this._global.selectedPlanYear = planYears[0]
                        else if (currentyear === planYears[1]) this._global.selectedPlanYear = planYears[1]
                        else this._global.selectedPlanYear = planYears[0]
                    } else {
                        this._global.selectedPlanYear = Number(planYearStr)
                    }
                }
            }
            this.setPageData()
        })
    }

    setAgentDetails() {
        // get address phone number from esoa model
        this._networkUserAccessGateway.GetCurrentUserForESoa().subscribe((usersoa) => {
            if (usersoa != null) {
                this.currentUserForESoa = usersoa

                //  this.soaSubmitDetails.AgentAddress = this.currentUserForESoa.AddressLine1 + ', ' +
                //    this.currentUserForESoa.AddressLine2 + ', ' + this.currentUserForESoa.City + ', ' +
                //  this.currentUserForESoa.State + ', ' + this.currentUserForESoa.Zip

                //   this.soaSubmitDetails.AgentPhone = this.currentUserForESoa.Phone.slice(0, 3) + '-' + this.currentUserForESoa.Phone.slice(3, 6) + '-' +
                //     this.currentUserForESoa.Phone.slice(6, 10)
                this.soaSubmitDetails.AgentPhone = this.currentUserForESoa.Phone

                this.soaSubmitDetails.AgentAddress = ''
                if (this.currentUserForESoa.AddressLine1 != null && this.currentUserForESoa.AddressLine1 != undefined) {
                    this.soaSubmitDetails.AgentAddress = this.soaSubmitDetails.AgentAddress + this.currentUserForESoa.AddressLine1 + ', '
                }
                if (
                    this.currentUserForESoa.AddressLine2 != null &&
                    this.currentUserForESoa.AddressLine2 != undefined &&
                    this.currentUserForESoa.AddressLine2 !== ''
                ) {
                    this.soaSubmitDetails.AgentAddress = this.soaSubmitDetails.AgentAddress + this.currentUserForESoa.AddressLine2 + ', '
                }
                if (this.currentUserForESoa.City != null && this.currentUserForESoa.City != undefined) {
                    this.soaSubmitDetails.AgentAddress = this.soaSubmitDetails.AgentAddress + this.currentUserForESoa.City + ', '
                }

                if (this.currentUserForESoa.State != null && this.currentUserForESoa.State != undefined) {
                    this.soaSubmitDetails.AgentAddress = this.soaSubmitDetails.AgentAddress + this.currentUserForESoa.State + ', '
                }

                if (this.currentUserForESoa.Zip != null && this.currentUserForESoa.Zip != undefined) {
                    this.soaSubmitDetails.AgentAddress = this.soaSubmitDetails.AgentAddress + this.currentUserForESoa.Zip
                }
                this.setExternalData()
            } else {
                // already exists in session
                //this.soaSubmitDetails.AgentAddress = this.currentUserForESoa.AddressLine1 + ', ' +
                //  this.currentUserForESoa.AddressLine2 + ', ' + this.currentUserForESoa.City + ', ' +
                //this.currentUserForESoa.State + ', ' + this.currentUserForESoa.Zip

                //  this.soaSubmitDetails.AgentPhone = this.currentUserForESoa.Phone.slice(0, 3) + '-' + this.currentUserForESoa.Phone.slice(3, 6) + '-' +
                //    this.currentUserForESoa.Phone.slice(6, 10)

                this.soaSubmitDetails.AgentPhone = this.currentUserForESoa.Phone

                this.soaSubmitDetails.AgentAddress = ''
                if (this.currentUserForESoa.AddressLine1 != null && this.currentUserForESoa.AddressLine1 != undefined) {
                    this.soaSubmitDetails.AgentAddress = this.soaSubmitDetails.AgentAddress + this.currentUserForESoa.AddressLine1 + ', '
                }
                if (this.currentUserForESoa.AddressLine2 != null && this.currentUserForESoa.AddressLine2 != undefined) {
                    this.soaSubmitDetails.AgentAddress = this.soaSubmitDetails.AgentAddress + this.currentUserForESoa.AddressLine2 + ', '
                }
                if (this.currentUserForESoa.City != null && this.currentUserForESoa.City != undefined) {
                    this.soaSubmitDetails.AgentAddress = this.soaSubmitDetails.AgentAddress + this.currentUserForESoa.City + ', '
                }

                if (this.currentUserForESoa.State != null && this.currentUserForESoa.State != undefined) {
                    this.soaSubmitDetails.AgentAddress = this.soaSubmitDetails.AgentAddress + this.currentUserForESoa.State + ', '
                }

                if (this.currentUserForESoa.Zip != null && this.currentUserForESoa.Zip != undefined) {
                    this.soaSubmitDetails.AgentAddress = this.soaSubmitDetails.AgentAddress + this.currentUserForESoa.Zip
                }

                this.setExternalData()
            }
        })
    }

    setExternalData() {
        this.route.params.subscribe((params) => {
            if (params['ak'] !== undefined && params['eid'] !== undefined) {
                this.setDataforSSO(params['ak'], params['eid'])
            }
        })
    }

    setDataforSSO(ak: string, eid: string) {
        this.enrollmentHeader.EnrollmentID = eid
        this.enrollmentHeader.accesskey = ak

        //Service call to set external data
        this.loading = true
        this.gateway.getEnrollmentHeader(this.enrollmentHeader).subscribe(
            (model: EnrollmentField[]) => {
                for (let i = 0; i < model.length; i++) {
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.PLANTYPE) {
                        if (model[i].FieldValue === 'C') {
                            this.soaSubmitDetails.Plan = 'CHOICE'
                        } else if (model[i].FieldValue === 'P') {
                            this.soaSubmitDetails.Plan = 'PLUS'
                        } else if (model[i].FieldValue === 'A') {
                            this.soaSubmitDetails.Plan = 'ALLURE'
                        } else {
                            this.soaSubmitDetails.Plan = model[i].FieldValue
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPFN) {
                        let fname: string = ''
                        let mi: EnrollmentField | undefined
                        let lname: EnrollmentField | undefined

                        fname = model[i].FieldValue
                        mi = model.find((x) => x.FieldCode === ExternalEnrollmentFieldCodes.APPMI)
                        lname = model.find((x) => x.FieldCode === ExternalEnrollmentFieldCodes.APPLN)
                        if (mi !== undefined && mi !== null && mi.FieldValue !== '') {
                            this.soaSubmitDetails.BeneficiaryName = fname + ' ' + mi.FieldValue
                        } else {
                            this.soaSubmitDetails.BeneficiaryName = fname
                        }
                        if (lname !== undefined && lname !== null && lname.FieldValue !== '') {
                            this.soaSubmitDetails.BeneficiaryName += ' ' + lname.FieldValue
                        }
                    }
                    //if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPMI) {
                    //    this.benefitaryModel.middleInitial = model[i].FieldValue
                    //}
                    //if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPLN) {
                    //    this.benefitaryModel.lastName = model[i].FieldValue
                    //}
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPPHONE) {
                        this.soaSubmitDetails.BeneficiaryPhone = model[i].FieldValue
                    }

                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPEMAIL) {
                        this.soaSubmitDetails.BeneficiaryEmail = model[i].FieldValue
                    }

                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPADD1) {
                        this.soaSubmitDetails.BeneficiaryAddress = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPADD2) {
                        let addr = ''
                        if (this.soaSubmitDetails.BeneficiaryAddress !== undefined && this.soaSubmitDetails.BeneficiaryAddress !== '') {
                            addr = this.soaSubmitDetails.BeneficiaryAddress + ' '
                        }
                        this.soaSubmitDetails.BeneficiaryAddress = addr + model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPCITY) {
                        let addr = ''
                        if (this.soaSubmitDetails.BeneficiaryAddress !== undefined && this.soaSubmitDetails.BeneficiaryAddress !== '') {
                            addr = this.soaSubmitDetails.BeneficiaryAddress + ' '
                        }
                        this.soaSubmitDetails.BeneficiaryAddress = addr + model[i].FieldValue
                    }
                    //if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPZIP) {
                    //    this.residentialAddress.zip = model[i].FieldValue
                    //}
                    //if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPST) {
                    //    this.residentialAddress.state = model[i].FieldValue
                    //}
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.PLANYEAR) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== '0') {
                            this.soaSubmitDetails.PlanYear = Number(model[i].FieldValue)
                        } else {
                            this.soaSubmitDetails.PlanYear = this._global.selectedPlanYear
                        }
                    }
                }
                this.loading = false
            },
            (err) => {
                this.loading = false
            }
        )
    }
    getValue(): BeneficiarySoaSubmitDetail {
        return this.soaSubmitDetails
    }

    getLabel(): string {
        return ''
    }

    sendEmail(): void {
        if (sessionStorage.getItem('GoodStandingParams') !== null) {
            this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams')!)
            if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
                this.haserror = true
                if (!this.goodStandingValues.CurriculumStatus) {
                    this.errorMessages.push(this.soaSubmitDetails.AgentName + 'has not passed training for' + this._global.selectedPlanYear + '<br/>')
                }
                if (!this.goodStandingValues.BackgroundCheckStatus) {
                    this.errorMessages.push(this.soaSubmitDetails.AgentName + ' background check not approved.<br/>')
                }
                if (!this.goodStandingValues.LicenseStatus) {
                    this.errorMessages.push(this.soaSubmitDetails.AgentName + ' does not have any valid license.<br/>')
                }
                return
            }
        }

        this.loading = true
        // console.log('agentName' + this.soaSubmitDetails.AgentName)
        // console.log('agentaddr' + this.soaSubmitDetails.AgentAddress)
        console.log('benphone' + this.soaSubmitDetails.BeneficiaryPhone)
        // console.log('benaddr' + this.soaSubmitDetails.BeneficiaryAddress)
        // console.log('InitalContact' + this.soaSubmitDetails.ContactMethod)
        // console.log('agnSignature' + this.soaSubmitDetails.AgentSignatureName)
        // console.log('plans' + this.soaSubmitDetails.Plan)
        // console.log('dateofApp' + this.soaSubmitDetails.ApplicationDate)
        // console.log('benEmail' + this.soaSubmitDetails.BeneficiaryEmail)
        // console.log('Agent Address' + this.soaSubmitDetails.AgentAddress)
        console.log('Agent Phone' + this.soaSubmitDetails.AgentPhone)
        // console.log('current plan year' + this.soaSubmitDetails.PlanYear)

        // console.log('this.validateForm()' + this.validateForm())

        if (!this.validateForm()) {
            this.isFormValid = false
            this.loading = false
            return
        } else {
            // console.log('this.validateForm() passed')

            this.isFormValid = true
            if (!this.soaSubmitDetails.AgentPhone.includes('-')) {
                this.soaSubmitDetails.AgentPhone =
                    this.soaSubmitDetails.AgentPhone.slice(0, 3) +
                    '-' +
                    this.soaSubmitDetails.AgentPhone.slice(3, 6) +
                    '-' +
                    this.soaSubmitDetails.AgentPhone.slice(6, 10)
            }
            if (!this.soaSubmitDetails.BeneficiaryPhone.includes('-')) {
                this.soaSubmitDetails.BeneficiaryPhone =
                    this.soaSubmitDetails.BeneficiaryPhone.slice(0, 3) +
                    '-' +
                    this.soaSubmitDetails.BeneficiaryPhone.slice(3, 6) +
                    '-' +
                    this.soaSubmitDetails.BeneficiaryPhone.slice(6, 10)
            }
            console.log('benphone after' + this.soaSubmitDetails.BeneficiaryPhone)
            console.log('Agent Phone after' + this.soaSubmitDetails.AgentPhone)

            this.soaFormSubmissionGateWay.sendEmail(this.soaSubmitDetails).subscribe(
                (model: boolean) => {
                    console.log('BACKENDCALL')
                    //  this.router.navigateByUrl('/electronic-soa/soaviewsubmissionconf' + this.soaSubmitDetails.BeneficaryEmail)
                    const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

                    let url = '/' + insCo + '/electronic-soa/soaviewsubmissionconf/' + this.soaSubmitDetails.BeneficiaryEmail
                    this.loading = false
                    this.router.navigateByUrl(url)
                },
                (err) => {
                    this.loading = false
                }
            )
        }
    }

    validateForm(): boolean {
        this.txtWhyNoDocsError = ''
        // alert(this.soaSubmitDetails.ApplicationDate)
        let isallValid = false
        let benNameValid = false
        let agentNameValid = false
        let agentPhoneValid = false
        let agentAdreessValid = false
        let benPhoneValid = false
        let benAddressValid = false
        let plansValid = false
        let emailValid = false
        let dateSelectValid = false
        let txtWhyNoDocsValid = true
        let agentSignValid = false
        let contactMethodvalid = false

        if (this.soaSubmitDetails.AgentName === undefined || this.soaSubmitDetails.AgentName === '' || this.soaSubmitDetails.AgentName === null) {
            agentNameValid = false
            this.agentNameError = 'Please fill out the Agent Name'
            this.specialCharacterAgentNameError = "Please don't enter any special characters or numbers."
        } else {
            if (/^[a-zA-Z\s]*$/.test(this.soaSubmitDetails.AgentName)) {
                this.agentNameError = ''
                this.specialCharacterAgentNameError = ''
                agentNameValid = true
            } else {
                this.agentNameError = ''
                this.specialCharacterAgentNameError = "Please don't enter any special characters or numbers."
                agentNameValid = false
            }
        }
        // Agent Phone
        if (this.soaSubmitDetails.AgentPhone === undefined || this.soaSubmitDetails.AgentPhone === '' || this.soaSubmitDetails.AgentPhone === null) {
            agentPhoneValid = false
            this.agentPhoneError = 'Agent Phone cannot be blank.'
            this.agentPhoneFormatError = 'Agent Phone must be exactly 10 numbers.'
        } else {
            let agentPhone = this.soaSubmitDetails.AgentPhone.replace(/-/g, '')
            if (/^\d{10}$/.test(agentPhone)) {
                this.agentPhoneError = ''
                this.agentPhoneFormatError = ''
                agentPhoneValid = true
            } else {
                if (!this.isValidNumber(agentPhone)) {
                    this.agentPhoneError = ''
                    this.agentPhoneFormatError = 'Agent Phone cannot contain letters or special characters.'
                    agentPhoneValid = false
                } else {
                    this.agentPhoneError = ''
                    this.agentPhoneFormatError = 'Agent Phone must be exactly 10 numbers.'
                    agentPhoneValid = false
                }
            }
        }

        // Agent Address
        if (
            this.soaSubmitDetails.AgentAddress === undefined ||
            this.soaSubmitDetails.AgentAddress === '' ||
            this.soaSubmitDetails.AgentAddress === null
        ) {
            agentAdreessValid = false
            this.agentAddressError = 'Please fill out the Agent Address.'
        } else {
            agentAdreessValid = true
            this.agentAddressError = ''
        }

        // Beneficiary name
        if (
            this.soaSubmitDetails.BeneficiaryName === undefined ||
            this.soaSubmitDetails.BeneficiaryName === '' ||
            this.soaSubmitDetails.BeneficiaryName === null
        ) {
            benNameValid = false
            this.beneficiaryNameError = 'Please fill out the Beneficiary Name'
            this.specialCharacterBeneficiaryNameError = "Please don't enter any special characters or numbers."
        } else {
            if (/^[a-zA-Z\s]*$/.test(this.soaSubmitDetails.BeneficiaryName)) {
                this.beneficiaryNameError = ''
                this.specialCharacterBeneficiaryNameError = ''
                benNameValid = true
            } else {
                this.beneficiaryNameError = ''
                this.specialCharacterBeneficiaryNameError = "Please don't enter any special characters or numbers."
                benNameValid = false
            }
        }

        if (
            this.soaSubmitDetails.BeneficiaryPhone === undefined ||
            this.soaSubmitDetails.BeneficiaryPhone === '' ||
            this.soaSubmitDetails.BeneficiaryPhone === null
        ) {
            benPhoneValid = false
            this.beneficiaryPhoneError = 'Beneficiary Phone cannot be blank.'
            this.beneficiaryPhoneFormatError = 'Beneficiary Phone must be exactly 10 numbers.'
        } else {
            let benPhone = this.soaSubmitDetails.BeneficiaryPhone.replace(/-/g, '')
            if (/^\d{10}$/.test(benPhone)) {
                this.beneficiaryPhoneError = ''
                this.beneficiaryPhoneFormatError = ''
                benPhoneValid = true
            } else {
                if (!this.isValidNumber(benPhone)) {
                    this.beneficiaryPhoneError = ''
                    this.beneficiaryPhoneFormatError = 'Beneficiary Phone cannot contain letters or special characters.'
                    benPhoneValid = false
                } else {
                    this.beneficiaryPhoneError = ''
                    this.beneficiaryPhoneFormatError = 'Beneficiary Phone must be exactly 10 numbers.'
                    benPhoneValid = false
                }
            }
        }

        console.log('benadr again' + this.soaSubmitDetails.BeneficiaryAddress)

        // Beneficiary Address
        if (
            this.soaSubmitDetails.BeneficiaryAddress === undefined ||
            this.soaSubmitDetails.BeneficiaryAddress === '' ||
            this.soaSubmitDetails.BeneficiaryAddress === null
        ) {
            benAddressValid = false
            this.beneficiaryAddressError = 'Please fill out the Beneficiary Address.'
        } else {
            benAddressValid = true
            this.beneficiaryAddressError = ''
        }

        // Method Of Contact
        if (
            this.soaSubmitDetails.ContactMethod === undefined ||
            this.soaSubmitDetails.ContactMethod === '' ||
            this.soaSubmitDetails.ContactMethod === null
        ) {
            contactMethodvalid = false
            this.beneficiaryMethodOfContactError = 'Please fill out the Method Of Contact'
            this.specialCharacterBeneficiaryMethodOfContactError = "Please don't enter any special characters or numbers."
        } else {
            if (/^[a-zA-Z\s\-]*$/.test(this.soaSubmitDetails.ContactMethod)) {
                this.beneficiaryMethodOfContactError = ''
                this.specialCharacterBeneficiaryMethodOfContactError = ''
                contactMethodvalid = true
            } else {
                this.beneficiaryMethodOfContactError = ''
                this.specialCharacterBeneficiaryMethodOfContactError = "Please don't enter any special characters or numbers."
                contactMethodvalid = false
            }
        }

        // Agent Signature
        console.log(this.soaSubmitDetails.AgentSignatureName)
        if (
            this.soaSubmitDetails.AgentSignatureName === undefined ||
            this.soaSubmitDetails.AgentSignatureName === '' ||
            this.soaSubmitDetails.AgentSignatureName === null
        ) {
            agentSignValid = false
            this.agentSignatureError = 'Please fill out the Agent Signature'
            this.specialCharacterAgentSignatureError = "Please don't enter any special characters or numbers."
        } else {
            if (/^[a-zA-Z\s]*$/.test(this.soaSubmitDetails.AgentSignatureName)) {
                this.agentSignatureError = ''
                this.specialCharacterAgentSignatureError = ''
                agentSignValid = true
            } else {
                this.agentSignatureError = ''
                this.specialCharacterAgentSignatureError = "Please don't enter any special characters or numbers."
                agentSignValid = false
            }
        }

        // Plans
        console.log(this.soaSubmitDetails.Plan)
        if (this.soaSubmitDetails.Plan === undefined || this.soaSubmitDetails.Plan === '' || this.soaSubmitDetails.Plan === null) {
            plansValid = false
            this.planError = 'Please fill out the Plans.'
        } else {
            plansValid = true
            this.planError = ''
        }

        // this.soaSubmitDetails.ApplicationDate = new Date()

        // Date Of Appointment

        console.log(this.soaSubmitDetails.ApplicationDate)
        if (this.soaSubmitDetails.ApplicationDate === undefined || this.soaSubmitDetails.ApplicationDate === null) {
            dateSelectValid = false
            this.dateOfAppointmentError = 'Please fill out the Date Of Appointment.'
        } else {
            let applicationDate = moment(this.soaSubmitDetails.ApplicationDate, 'MM/DD/YYYY', true)
            //if ((applicationDate.format('MM/DD/YYYY') >= moment().format('MM/DD/YYYY'))) {

            if (moment().isSameOrBefore(applicationDate, 'day')) {
                //if ((applicationDate.format('MM/DD/YYYY') >= moment().format('MM/DD/YYYY'))) {

                this.dateOfAppointmentError = ''
                dateSelectValid = true
            } else {
                dateSelectValid = false
                this.dateOfAppointmentError = "The Date of Appointment cannot be prior to today's date"
            }
        }

        //----Removed this  logic, not same as existing agent portal logic
        //if (dateSelectValid) {
        //    let appDate = moment(this.soaSubmitDetails.ApplicationDate).format("MM/DD/YYYY")
        //    let todayDate = moment(new Date()).format("MM/DD/YYYY")

        //    if (appDate < todayDate ) {

        //        if(this.soaSubmitDetails.Instructions === undefined
        //            || this.soaSubmitDetails.Instructions === null) {

        //            txtWhyNoDocsValid = false
        //            this.txtWhyNoDocsError = 'Appointment Date is past. Please enter reason.'

        //        } else if (this.soaSubmitDetails.Instructions.trim() === '') {
        //            txtWhyNoDocsValid = false
        //            this.txtWhyNoDocsError = 'Appointment Date is past. Please enter reason.'
        //        }

        //    }
        //}

        // Beneficiary Email Address
        console.log(this.soaSubmitDetails.BeneficiaryEmail)
        if (
            this.soaSubmitDetails.BeneficiaryEmail === undefined ||
            this.soaSubmitDetails.BeneficiaryEmail === '' ||
            this.soaSubmitDetails.BeneficiaryEmail === null
        ) {
            emailValid = false
            this.beneficiaryEmailError = 'Please fill out the Beneficiary Email.'
            // this.specialCharacterbeneficiaryEmailError = 'Please type in a valid Email Format(x@x.xx).'
        } else {
            let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
            let checkOrgEmail = this.soaSubmitDetails.BeneficiaryEmail.toLowerCase()
            //regexVal = new RegExp(
            //    `^` +
            //    `(` +
            //    `?:[a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*|"` +
            //    `${unicodeRange}*"` +
            //    `)` +
            //    `@` +
            //    `(` +
            //    `?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+` +
            //    `[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|` +
            //    `\\[` +
            //    `(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}` +
            //    `(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:${unicodeRange}+)` +
            //    `\\]` +
            //    `)` +
            //    `$`
            //)
            let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
            if (!isOrgEmailValid) {
                this.beneficiaryEmailError = ''
                this.specialCharacterbeneficiaryEmailError = 'Invalid Email ID'
                emailValid = false
            } else {
                this.beneficiaryEmailError = ''
                this.specialCharacterbeneficiaryEmailError = ''
                emailValid = true
            }
        }
        if (
            benNameValid &&
            agentNameValid &&
            agentPhoneValid &&
            agentAdreessValid &&
            benPhoneValid &&
            benAddressValid &&
            plansValid &&
            emailValid &&
            dateSelectValid &&
            agentSignValid &&
            contactMethodvalid &&
            txtWhyNoDocsValid
        ) {
            return (isallValid = true)
        }
        return isallValid

        //  }
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }

    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.sendEmail()
        }
    }
    GetTrainingURL() {
        //this.trainingCertificatesGateway.LogintoCourseGuide(this._global.currentUser.userProfileName,
        //    this._global.selectedPlanYear).subscribe
        //    ((data) => {
        //        window.open(data, '_blank')
        //    })
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.routers.navigate(['/' + insCo + '/training/trainingDetail'])
    }
    private setOrgname() {
        if (this._global.selectedPlanYear === 0 || this._global.selectedPlanYear === undefined) {
            if (sessionStorage.getItem('PLANYEAR') !== undefined) {
                this._global.selectedPlanYear = Number(sessionStorage.getItem('PLANYEAR'))
            }
        }
        if (Number(this._global.selectedPlanYear) === this._global.CurrentYear) {
            this.insuranceCompany = this.currentUser.insuranceCompanyName
            this.insuranceCompanyShortName = this._global.insCompanyNameSSI
        } else {
            this.insuranceCompany = this._global.insCompanyNameAetna
            this.insuranceCompanyShortName = this._global.insuranceCompanyNameAetna
        }
    }
}
